import { useCompanyValues } from '@/providers';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { EXTERNAL_FOOTER_LOGOS } from './constants';
import { PoweredBy } from './PoweredBy';

type ExternalFooterProps = {
  className?: string;
};

export const ExternalFooter: FC<ExternalFooterProps> = ({ className }) => {
  const { company } = useCompanyValues();

  return (
    <footer className={twMerge('flex justify-between h-footer gap-20 bg-yellow-500 px-20 py-[1.1075rem] text-yellow-700', className)}>
      {EXTERNAL_FOOTER_LOGOS[company]}
      <PoweredBy />
    </footer>
  );
};
